(function () {
  var REVEAL_STAGGER_S = 0.07;
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;

  function ensureSlideLoaded(slide) {
    return new Promise(function (resolve) {
      if (!slide) {
        resolve();
        return;
      }

      if (slide.dataset.imageLoaded === 'true') {
        resolve();
        return;
      }

      function markReady() {
        slide.dataset.imageLoaded = 'true';
        slide.classList.add('is-image-ready');
        resolve();
      }

      if (slide.complete && slide.naturalWidth > 0) {
        markReady();
      } else {
        slide.addEventListener('load', markReady, { once: true });
        slide.addEventListener('error', markReady, { once: true });
      }
    });
  }

  function initImageContainer(container) {
    if (!container || container.dataset.carouselReady === 'true') return;
    container.dataset.carouselReady = 'true';

    var slide = container.querySelector('.product-image-slide');
    if (!slide) return;

    ensureSlideLoaded(slide).then(function () {
      slide.classList.add('is-active');
    });
  }

  function startImageLoad(container) {
    if (!container || container.classList.contains('is-loaded')) return;

    window.requestAnimationFrame(function () {
      container.classList.add('is-loaded');
    });

    initImageContainer(container);
  }

  function revealCard(card) {
    if (card.classList.contains('is-revealed')) return;

    card.classList.add('is-revealed');

    var container = card.querySelector('[data-image-carousel]');
    if (container) startImageLoad(container);
  }

  function initProductCardReveal(root) {
    var scope = root || document;

    if (prefersReducedMotion) {
      scope.querySelectorAll('.product-card[data-product-reveal]').forEach(revealCard);
      scope.querySelectorAll('[data-image-carousel]:not([data-carousel-ready])').forEach(initImageContainer);
      return;
    }

    var cards = scope.querySelectorAll('.product-card[data-product-reveal]:not([data-reveal-ready])');
    if (!cards.length) return;

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            revealCard(entry.target);
            revealObserver.unobserve(entry.target);
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -4% 0px',
          threshold: 0.12
        }
      );
    }

    cards.forEach(function (card, index) {
      card.dataset.revealReady = 'true';
      var staggerIndex = Number(card.dataset.revealIndex);
      if (Number.isNaN(staggerIndex)) staggerIndex = index;
      card.style.setProperty('--reveal-delay', staggerIndex * REVEAL_STAGGER_S + 's');
      card.style.setProperty('--image-zoom-delay', staggerIndex * REVEAL_STAGGER_S + 0.12 + 's');

      var container = card.querySelector('[data-image-carousel]');
      if (container) {
        container.style.setProperty('--image-zoom-delay', staggerIndex * REVEAL_STAGGER_S + 0.12 + 's');
      }

      revealObserver.observe(card);
    });
  }

  function initStandaloneImages(root) {
    (root || document)
      .querySelectorAll('[data-image-carousel]:not([data-carousel-ready])')
      .forEach(function (container) {
        var card = container.closest('.product-card[data-product-reveal]');
        if (card) return;

        startImageLoad(container);
      });
  }

  function initProductImageExperience(root) {
    initProductCardReveal(root);
    initStandaloneImages(root);
  }

  function scheduleInit() {
    var run = function () {
      initProductImageExperience();
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 0);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit, { once: true });
  } else {
    scheduleInit();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProductImageExperience(event.target);
  });

  window.initProductImageCarousels = initImageContainer;
  window.initProductImageExperience = initProductImageExperience;
})();
